import { Field } from 'formik';
import { useServiceManagerFieldQuery } from '../../generated/graphql';
import useConcession from '../../hooks/useConcession';
import { ContractConcessionOrganizationUser } from '../../types/types';
import { ContractUserAutocomplete } from '../ContractUserAutocomplete/ContractUserAutocomplete';

export default function ServiceManagerField(props: ContractConcessionOrganizationUser) {
    const { disabled } = props
    const concession = useConcession()
    const { data } = useServiceManagerFieldQuery({ fetchPolicy: "no-cache", variables: { concession: concession?.id } })

    const name = "contractUsers"
    const label = "Gestor Obra"
    const options = data?.concessionUsers?.nodes || []
    const role = "SERVICEMANAGER"

    return (
        <Field
            name={name}
            component={ContractUserAutocomplete}
            options={options}
            label={label}
            role={role}
            disabled={disabled}
        />
    )
}
